// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"16a611f4","793":"b42fd198"}[chunkId] + ".chunk.js";
};